var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardTabRtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H2V6H4V18ZM12 18L6 12L12 6L13.4 7.4L9.825 11H22V13H9.825L13.425 16.6L12 18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardTabRtl);
export default __webpack_public_path__ + "static/media/keyboard_tab_rtl.949546a368d7f7f1e4e68c16acc91c9c.svg";
export { ForwardRef as ReactComponent };